if (!customElements.get('card-images')) {
  class CardImages extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.card-images__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;

      this.calcItemMinHeight();

      if (!this.enableSlider) return;

      this.init();
    }

    init() {
      this.initSlider();
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: 1.15,
        spaceBetween: 12,
        loop: true,
        loopedSlides: this.querySelectorAll('.swiper-slide').length,
        threshold: 2,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        breakpoints: {
          768: {
            slidesPerView: 1.15,
            spaceBetween: 12,
          },
          1024: {
            slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop,
          },
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }

    /**
     * Make sure overlay content display properly without overlap image.
     */
    calcItemMinHeight() {
      let maxHeight = 0;
      const cardMedias = this.querySelectorAll('.card-media');
      cardMedias &&
        cardMedias.forEach((cardMedia) => {
          const cardContent = cardMedia.querySelector('.card-media__content');
          if (!cardContent) return;

          const cardContentInner = cardContent.querySelector('.card-media__content-wrapper');
          const cardContentPadding = this.getElementPadding(cardContent);
          let itemHeight = cardContentInner.offsetHeight;

          if (cardContentPadding) {
            itemHeight += cardContentPadding.top + cardContentPadding.bottom;
          }

          if (itemHeight > maxHeight) {
            maxHeight = itemHeight;
          }

          cardMedia.style.setProperty('--item-height', itemHeight + 'px');
        });

      this.style.setProperty('--items-height', maxHeight + 'px');
    }

    getElementPadding(element) {
      if (!element) {
        return null;
      }

      const style = window.getComputedStyle(element);
      const paddingTop = parseFloat(style.paddingTop);
      const paddingBottom = parseFloat(style.paddingBottom);

      return {
        top: paddingTop,
        bottom: paddingBottom,
      };
    }
  }
  customElements.define('card-images', CardImages);
}

/* ── Zoy: Inject icons into card-image list items ── */
(function () {
  const ICONS = {
    sparkle: `<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0 C10 0 11 5.5 11.8 7.2 C12.6 8.9 14 10 14 10 C14 10 12.6 11.1 11.8 12.8 C11 14.5 10 20 10 20 C10 20 9 14.5 8.2 12.8 C7.4 11.1 6 10 6 10 C6 10 7.4 8.9 8.2 7.2 C9 5.5 10 0 10 0Z" fill="currentColor"/>
      <path d="M0 10 C0 10 5.5 9 7.2 8.2 C8.9 7.4 10 6 10 6 C10 6 11.1 7.4 12.8 8.2 C14.5 9 20 10 20 10 C20 10 14.5 11 12.8 11.8 C11.1 12.6 10 14 10 14 C10 14 8.9 12.6 7.2 11.8 C5.5 11 0 10 0 10Z" fill="currentColor"/>
    </svg>`,
    check: `<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/>
      <path d="M6 10L8.5 12.5L14 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
    dot: `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5" cy="5" r="5" fill="currentColor"/>
    </svg>`,
  };

  function injectIcons() {
    document.querySelectorAll('.card-media__icon-list-wrap').forEach((wrap) => {
      if (wrap.dataset.iconsInjected) return;
      wrap.dataset.iconsInjected = '1';

      const style   = wrap.dataset.iconStyle || 'sparkle';
      const iconUrl = wrap.dataset.iconUrl || '';
      const lis     = wrap.querySelectorAll('li');

      lis.forEach((li) => {
        if (li.querySelector('.card-media__list-icon')) return;
        const span = document.createElement('span');
        span.className = 'card-media__list-icon';
        span.setAttribute('aria-hidden', 'true');

        if (iconUrl) {
          span.innerHTML = `<img src="${iconUrl}" alt="" width="20" height="20" loading="lazy">`;
        } else {
          span.innerHTML = ICONS[style] || ICONS.sparkle;
        }

        li.insertBefore(span, li.firstChild);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectIcons);
  } else {
    injectIcons();
  }

  // Re-run on theme editor changes
  document.addEventListener('shopify:section:load', injectIcons);
  document.addEventListener('shopify:block:select', injectIcons);
})();
